<template>
	<div>
		<a-page-header style="background: #fff;" title="信息分类" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'信息分类'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addModal = true">
					添加分类
				</a-button>
			</template>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :loading="loading">
					<span slot="cityinfoClassPic" slot-scope="cityinfoClassPic">
						<a-avatar :src="cityinfoClassPic" size="large" />
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加信息分类弹出 -->
		<a-modal title="添加信息分类" v-model="addModal" @ok="addSubmit" cancelText="取消" okText="添加" width="50%">
			<a-form-model ref="addForm" :model="addForm" :rules="addRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="分类名称" prop="cityinfoName">
					<a-input v-model="addForm.cityinfoName" />
				</a-form-model-item>
				<a-form-model-item label="分类图标" prop='cityinfoClassPic'>
					<a-upload name="img" :multiple="true" listType="picture-card" :showUploadList="false" class="avatar-uploader"
					  :action="this.$host+'/admin/index.php/admin/qiniu/uploads'" @change="addPicChange">
						<img v-if="addForm.cityinfoClassPic" :src="addForm.cityinfoClassPic" alt="avatar" style=" width: 150px;height: 150px;" />
						<div v-else>
							<a-icon :type="loading ? 'loading' : 'plus'" />
							<div class="ant-upload-text">上传</div>
						</div>
					</a-upload>
				</a-form-model-item>
				<a-form-model-item label="排序" prop='order'>
					<a-input v-model="addForm.order" />
					<div style="color: #ffa940;">数字越大排序越靠前 例如 100 > 99</div>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改信息分类弹出 -->
		<a-modal title="编辑信息分类" v-model="editModal" @ok="editSubmit" cancelText="取消" okText="保存" width="50%">
			<a-form-model ref="editForm" :model="editForm" :rules="addRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="分类名称" prop="cityinfoName">
					<a-input v-model="editForm.cityinfoName"></a-input>
				</a-form-model-item>
				<a-form-model-item label="分类图标" prop='cityinfoClassPic'>
					<a-upload name="img" :multiple="true" listType="picture-card" :showUploadList="false" class="avatar-uploader"
					  :action="this.$host+'/admin/index.php/admin/qiniu/uploads'" @change="editPicChange">
						<img v-if="editForm.cityinfoClassPic" :src="editForm.cityinfoClassPic" alt="avatar" style=" width: 150px;height: 150px;" />
						<div v-else>
							<a-icon :type="loading ? 'loading' : 'plus'" />
							<div class="ant-upload-text">上传</div>
						</div>
					</a-upload>
				</a-form-model-item>
				<a-form-model-item label="排序" prop="order">
					<a-input v-model="editForm.order"></a-input>
					<div style="color: #ffa940;">数字越大排序越靠前 例如 100 > 99</div>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	var storage = window.localStorage
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '分类名称',
			dataIndex: 'cityinfoName',
			scopedSlots: {
				customRender: 'cityinfoName'
			},
		},
		{
			title: '分类图标',
			dataIndex: 'cityinfoClassPic',
			scopedSlots: {
				customRender: 'cityinfoClassPic'
			},
		},
		{
			title: '排序',
			dataIndex: 'order',
			scopedSlots: {
				customRender: 'order'
			},
		},
		{
			title: '添加时间',
			dataIndex: 'addTime',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				list: [],
				addForm: {},
				addModal: false,
				editForm: {},
				editModal: false,
				loading: false,
				addRules: {
					cityinfoName: [{
						required: true,
						message: '请填写信息分类名称',
						trigger: 'blur'
					}],
				},
			};
		},

		mounted() {
			this.getList()
		},

		methods: {
			addPicChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					this.addForm.cityinfoClassPic = info.file.response.url;
					this.loading = false;
				}
			},
			
			editPicChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					this.editForm.cityinfoClassPic = info.file.response.url;
					this.loading = false;
				}
			},
			
			toDetail(id) {
				this.classId = id
				this.$http.post('/admin/index.php/admin/News/cityInfo', {
					id: id
				}).then(res => {
					if (res.data.code == 1) {
						this.editForm = res.data.data
						this.editModal = true
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			addSubmit() {
				if (!this.addForm.cityinfoClassPic) {
					this.$message.error('请上传分类图标');
					return false
				}
				this.$refs.addForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/News/cityInfoSave', {
							cityinfoName: this.addForm.cityinfoName,
							cityinfoClassPic: this.addForm.cityinfoClassPic,
							order: this.addForm.order,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('添加成功！');
								this.addModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},
			
			editSubmit() {
				this.$refs.editForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/News/cityInfoSave', {
							id:this.classId,
							cityinfoName: this.editForm.cityinfoName,
							cityinfoClassPic: this.editForm.cityinfoClassPic,
							order: this.editForm.order,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('保存成功！');
								this.editModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},
			
			del(id) {
				this.$http.post('/admin/index.php/admin/News/cityInfoDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			getList() {
				this.loading = true
				this.$http.post('/admin/index.php/admin/News/cityInfoList').then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
